import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, ErrorHandler, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { provideNgxMask } from 'ngx-mask';

import * as Sentry from "@sentry/angular";

import { routes } from './app.routes';

import { authInterceptor } from 'anatoliapps-angular/auth';
import { i18nInterceptor } from 'hakikat/interceptors';
import { errorInterceptor } from './core/interceptors/http';

import { SettingsService } from 'hakikat/services';
import { DEFAULT_CURRENCIES, FIREBASE_CONFIG, Locale } from 'hakikat/utils';

import { AuthService } from './core/auth/auth.service';
import { LoggerService } from './core/services/logger.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      return inject(AuthService).initialize();
      // inject(ThemeService).initialize();
    }),

    // Angular
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor, i18nInterceptor, errorInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    })),

    // Firebase
    provideFirebaseApp(() => initializeApp(FIREBASE_CONFIG)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),

    // Third-Party Libraries
    provideNgxMask(),

    // Application Initializer Services
    {
      provide: DEFAULT_CURRENCY_CODE,
      useFactory: (settings: SettingsService) => {
        return settings.localization.currency || DEFAULT_CURRENCIES[inject(LOCALE_ID) as Locale] || 'EUR';
      },
      deps: [SettingsService]
    },
    // {
    //   provide: ErrorHandler,
    //   useFactory: (loggerService: LoggerService) => {
    //     return new (class implements ErrorHandler {
    //       handleError(error: Error): void {
    //         loggerService.log(error);
    //       }
    //     })();
    //   },
    //   deps: [LoggerService]
    // },

    // Sentry Services
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    }
  ]
};
